<template>
  <!-- 开票申请 -->
  <div>
    <div class="header">
      <i class="icon-fanhui iconfont icon back"
         @click="back"></i>
      <div>开票申请</div>
    </div>
    <div class="applycontent">
      <!-- tab栏 -->
      <div class="navlist">
        <span style="width:33%"
              :class="{active:tabState==navItem.id}"
              v-for="navItem in navList"
              :key="navItem.id"
              @click="getNav(navItem.id)">{{navItem.name}}</span>
      </div>
      <!-- tab栏 -->
      <!-- 开票信息 -->
      <div class="contentlist">
        <!-- 开票信息 -->
        <ticket-info v-show="tabState==1"
                     :operationStatus="operationStatus"
                     :infoFieldState="infoFieldState"
                     :editBaseData="editBaseData"
                     ref="ticketInfo"></ticket-info>
        <!-- 开票信息 -->
        <!-- 开票金额 -->
        <ticket-money v-show="tabState==2"
                      :operationStatus="operationStatus"
                      :moneyFieldState="moneyFieldState"
                      :editMoneyData="editMoneyData"
                      ref="ticketMoney"></ticket-money>
        <!-- 开票金额 -->
        <!-- 开票留言 -->
        <ticket-message v-show="tabState==3"
                        :operationStatus="operationStatus"
                        :messageFieldState="messageFieldState"
                        :editBaseData="editBaseData"
                        ref="ticketMessage"></ticket-message>
        <!-- 开票留言 -->

      </div>
      <!-- 开票信息 -->
    </div>
    <ticket-button :state="tabState"
                   @clickHandler="clickHandler"></ticket-button>

  </div>
</template>
<script>
  import ticketInfo from '../../components/Ticket/TicketInfo'
  import ticketMoney from '../../components/Ticket/TicketMoney'
  import ticketMessage from '../../components/Ticket/TicketMessage'

  import ticketButton from '../../components/Ticket/TicketButton'

  import { MessageBox, } from 'mint-ui';
  export default {
    components: {
      ticketInfo,
      ticketMoney,
      ticketMessage,
      ticketButton
    },
    data () {
      return {
        tabState: 1,
        navList: [{ id: 1, name: '开票信息' }, { id: 2, name: '开票金额' }, { id: 3, name: '开票留言' }],
        projectList: [],
        taxList: [],
        accountList: [],
        infoFieldState: {},//开票信息数据
        moneyFieldState: {},//开票金额数据
        messageFieldState: {},//开票留言数据
        editBaseData: {},//点击编辑得到的数据
        editMoneyData: [],//金额数据
        operationStatus: '0',//操作的步骤

      }
    },
    created () {
      this.editBaseData = this.$route.query.baseData
      if (this.$route.query.moneyData) { this.editMoneyData = JSON.parse(this.$route.query.moneyData) }
      this.operationStatus = this.$route.query.operationStatus
    },
    methods: {
      back () {//返回开票列表页面
        this.$router.push({ name: 'ticketlist' })
      },
      getNav (nav) {//tab栏的切换
        if (this.tabState == 1) {
          if (this.$refs['ticketInfo'].checkField()) {
            this.infoFieldState = this.$refs['ticketInfo'].checkField()
            this.tabState = nav
          }
        } else if (this.tabState == 2) {
          if (this.$refs['ticketMoney'].checkField()) {
            this.moneyFieldState = this.$refs['ticketMoney'].checkField()
            this.tabState = nav
          }
        } else if (this.tabState == 3) {
          if (this.$refs['ticketMessage'].checkField()) {
            this.messageFieldState = this.$refs['ticketMessage'].checkField()
            this.tabState = nav
          }
        }

      },
      // 按钮下一步
      clickHandler () {
        if (this.tabState == 1) {
          // 开票信息
          this.infoFieldState = this.$refs['ticketInfo'].checkField()
          if (this.infoFieldState) {//如果都不为空，跳转下个栏目
            this.tabState = 2
          }
        } else if (this.tabState == 2) {
          // 开票金额
          this.moneyFieldState = this.$refs['ticketMoney'].checkField()
          if (this.moneyFieldState) {//如果都不为空，跳转下个栏目
            this.tabState = 3
          }
        }
        else if (this.tabState == 3) {
          // 开票留言
          this.messageFieldState = this.$refs['ticketMessage'].checkField()
          if (this.messageFieldState) {
            let data = this.mergeData()
            this.$http.getInvoicingStore(data).then(res => {
              if (res.errCode == 0) {
                MessageBox('提示', '保存成功')
                this.$router.push({ name: 'ticketlist' })
              } else {
                MessageBox('提示', res.errMsg || '保存失败,请重试!')

              }
            })
          }
        }
      },

      mergeData () {//合并数据
        let allFormData = Object.assign({}, this.infoFieldState, this.moneyFieldState, this.messageFieldState)
        return allFormData //将参数整合在一起
      }
    },

  }
</script>
<style scoped>
  .header {
    width: 100%;
    text-align: center;
    font-size: 0.375rem;
    background-color: #fff;
    height: 1.04375rem;
    line-height: 1.09375rem;
    position: fixed;
    top: 0;
    z-index: 99;
    border-bottom: 1px solid #ccc;
  }
  .applycontent {
    background: #f7f7f7;
    margin-top: 1.04375rem;
  }
  .back {
    position: absolute;
    left: 0.1rem;
  }
  .navlist {
    text-align: center;
    display: flex;
    justify-content: space-around;
    font-size: 0.427rem;
    background: #fff;
    line-height: 1.2rem;
    height: 1.2rem;
  }
  .contentlist {
    background: #f7f7f7;
  }
  .active {
    color: #5483d2;
    border-bottom: 2px solid #5483d2;
  }
</style>




// WEBPACK FOOTER //
// src/components/Ticket/Index.vue